var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrompt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffff",
    d: "M14 1.5a.5.5 0 0 0-1 0V2h-.5a.5.5 0 0 0 0 1h.5v.5a.5.5 0 0 0 1 0V3h.5a.5.5 0 0 0 0-1H14zm-9.588.426C4.51 1.453 4.924 1 5.5 1s.99.453 1.089.926a3.2 3.2 0 0 0 .864 1.62a3.2 3.2 0 0 0 1.62.865c.473.098.926.512.926 1.09c0 .576-.453.99-.926 1.088a3.2 3.2 0 0 0-1.62.865a3.2 3.2 0 0 0-.864 1.62c-.098.472-.512.926-1.09.926c-.576 0-.99-.453-1.088-.926a3.2 3.2 0 0 0-.865-1.621a3.2 3.2 0 0 0-1.62-.864c-.472-.098-.925-.511-.926-1.087c-.001-.578.453-.993.926-1.091a3.2 3.2 0 0 0 1.62-.864a3.2 3.2 0 0 0 .865-1.62M11 5.5q0-.264-.06-.5h.56A2.5 2.5 0 0 1 14 7.5v4a2.5 2.5 0 0 1-2.5 2.5h-4A2.5 2.5 0 0 1 5 11.5v-.56a2.1 2.1 0 0 0 1 0v.56A1.5 1.5 0 0 0 7.5 13h4a1.5 1.5 0 0 0 1.5-1.5v-4A1.5 1.5 0 0 0 11.5 6h-.56q.06-.236.06-.5m-3 3a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H8.5a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1H10a.5.5 0 0 0 0-1zm-6 2a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 0 1H3v.5a.5.5 0 0 1-1 0V14h-.5a.5.5 0 0 1 0-1H2v-.5a.5.5 0 0 1 .5-.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrompt);
export default __webpack_public_path__ + "static/media/prompt.e4c23ba5f335a8cb992a8765353aa0e9.svg";
export { ForwardRef as ReactComponent };